import { createSlice } from "@reduxjs/toolkit";

// Define a type for the slice state
interface IInventoryItemStatusState {
  data: Array<IInventoryStatus> |null;
  pageSize: number;
  pageNumber: number;
  totalCount: number;
  showLoading: ILoading;
  isLoading: boolean;
  isSuccess: boolean;
  inventoryItemStatusDetails: IInventoryStatus | null ;
}

// Define the initial state using that type
const initialState: IInventoryItemStatusState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: '',
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  inventoryItemStatusDetails: null,
};

export const inventoryItemStatusSlice = createSlice({
  name: "inventoryItemStatus",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
    state.showLoading = {
    sourceAction: action.payload.sourceAction,
    state: true,
    };
    state.isLoading = action.payload.addInventoryItemStatusLoading ?? false;
    state.isSuccess = action.payload.addInventoryItemStatusSuccess ?? false;
    },

    resetLoading: (state, action) => {
    state.showLoading = {
    sourceAction: '',
    state: false,
    };
    state.isLoading = action.payload.addInventoryItemStatusLoading ?? false;
    state.isSuccess = action.payload.addInventoryItemStatusSuccess ?? false;
    },
    replaceInventoryItemStatus: (state, action) => {
      state.data = action.payload.data;
      state.pageSize = action.payload.pageSize;
      state.pageNumber = action.payload.pageNumber;
      state.totalCount = action.payload.totalCount;
    },
    addInventoryItemStatus: (state, action) => {
      const newItem = action.payload.data;
      if (state.data &&state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateInventoryItemStatus: (state, action) => {
        const { localID, data } = action.payload;
        if (localID !== undefined && localID >= 0 && state.data) {
          state.data[localID] = data;
        }
    },
    deleteInventoryItemStatus: (state, action) => {
      const inventoryItemStatusToRemove: IInventoryStatus = action.payload.data;
      const newInventoryItemStatusData = state.data && state.data.filter(
        (inventoryItemStatus: IInventoryStatus) => {
          return inventoryItemStatus.id !== inventoryItemStatusToRemove.id;
        }
      );
      state.data = newInventoryItemStatusData;
      state.totalCount = state.totalCount - 1;
    },
    setInventoryStatusDetails: (state, action) => {
      state.inventoryItemStatusDetails = action.payload.data;
    },
  },
});

export const inventoryItemStatusActions = inventoryItemStatusSlice.actions;

export default inventoryItemStatusSlice.reducer;
